import * as React from "react";
import { TextField, TextFieldProps } from "@origin-digital/ods-core";
import { FieldProps } from "formik";

type IPhoneNumberProps = FieldProps & TextFieldProps;

const PhoneNumber: React.FC<IPhoneNumberProps> = ({
  field,
  form,
  ...props
}) => {
  return (
    <TextField
      {...props}
      {...field}
      id="phone-number"
      variant="outlined"
      label="Phone"
      hideHelperTextSpace
      error={!!form.errors[field.name]}
      helperText={form.errors[field.name]?.toString()}
    />
  );
};

export default PhoneNumber;
